jQuery(function($){ 


  // Mobile Search
  $(".top-search").on("click", function(){
    $(".search_mobile").toggle();
  }); 

  
  // Toggle Active and non Active
  $(".mob-menu").on("click", function(){
    $(".slicknav_nav").toggleClass("slicknav_hidden");
    $(".slicknav_nav").toggle();    
  }); 


  // Accordion
  $(".desc-header").on("click",function(){$(this).parent().hasClass("active")?$(".desc-header").parent().removeClass("active"):($(".desc-header").parent().removeClass("active"),$(this).parent().addClass("active"))})

  // Anchor smooth scrolls
  $("body").on("click",".a-link",function(o){o.preventDefault();document.querySelector(this.getAttribute('href')).scrollIntoView({behavior: 'smooth'});$("body").removeClass("show-menu")});

  
});